import * as React from 'react'

export const HeaderShadow = () => {
  const shadow =
    'radial-gradient(at top, var(--color-border-main-old), rgba(0, 0, 0, 0) 70%) 0 0/100% 8px no-repeat'

  return (
    <div
      style={{background: shadow}}
      className="absolute left-0 right-0 h-16 -bottom-16 pointer-events-none"
    />
  )
}
